/**
 * @license Copyright (c) 2003-2017, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md.
 */

/**
 * @module utils/isiterable
 */

/**
 * Checks if value implements iterator interface.
 *
 * @param {*} value The value to check.
 * @returns {Boolean} True if value implements iterator interface.
 */
export default function isIterable( value ) {
	return !!( value && value[ Symbol.iterator ] );
}



//////////////////
// WEBPACK FOOTER
// ../ckeditor5-utils/src/isiterable.js
// module id = null
// module chunks = 